<template>
  <div class="label-container">
    <div class="label-content" :class="{ 'label-prepend': prepend }">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'case-logic-label',
  props: {
    prepend: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style scoped>
.label-container {
  display: inline-table;
  height: 36px; /* need to make this take up available height */
}

.label-content {
  background-color: rgb(250, 252, 253);
  color: rgb(151, 160, 190);
  border: 1px solid rgb(191, 198, 217);
  border-radius: 4px;
  padding: 0 10px;
  display: table-cell;
  vertical-align: middle;
  width: auto;
  white-space: nowrap;
}

.label-prepend {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
</style>